<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Terminal dispatching </li>
            </ol>
          </div>
          <h4 class="page-title">Terminal dispatching</h4>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Terminal dispatching</h4>
          <p class="sub-header">
            Terminal dispatching
          </p>

          <div class="row">
            <div class="form-group row" *ngIf="success" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert type="info" [dismissible]="false" style="width:100%;">
                  <strong></strong> {{message}}
                </ngb-alert>
              </div>
            </div>

            <div class="form-group" *ngIf="raiseDanger" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert type="danger" [dismissible]="false" style="width:100%;">
                  <strong>Error!</strong> {{danger}}
                </ngb-alert>
              </div>
            </div>

          </div>

          <div class="row form-horizontal">
            <div class="col-md-10 form-horizontal px-3">

              <div class="form-group row">
                <label class="col-4 col-form-label">Serial number/Waybill number/Merchant number </label>
                <div class="col-6">
                  <input class="form-control" type="text" name="serialNumber" [(ngModel)]="serialNumber" [ngModelOptions]="{standalone: true}" required>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="submit()">
                    Dispatch <i class="mdi mdi-pencil-box-outline"></i>
                  </button>
                </div>
              </div>
              <div class="form-group row">
                <label style="margin-left:10px;"><i>NB: Please note, for bulk orders, use the merchant number for dispatching.</i></label>
              </div>
            </div>
            <div class="col-md-12 form-horizontal px-3">

              <div class="form-group row" style="width:100%;">
                <div class="col-md-12 form-horizontal px-6" style="width:100%;">

                  <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
                    <thead>
                      <tr>
                        <td class="col-1">Terminal Id</td>
                        <td class="col-2">Waybill</td>
                        <td class="col-2">Serial Number</td>
                        <td class="col-2">Base Serial Number</td>
                        <td class="col-2">Sim number</td>
                        <td class="col-2">Merchant number</td>
                        <td class="col-2">Dispatched date</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let terminal of dispatchedTerminals">
                        <td>{{ terminal.terminalId}}</td>
                        <td>{{ terminal.wayBill}}</td>
                        <td>{{ terminal.serialNumber}}</td>
                        <td>{{ terminal.baseSerialNumber}}</td>
                        <td>{{ terminal.simNumber}}</td>
                        <td>{{ terminal.merchantNumber}}</td>
                        <td>{{ terminal.inUseDate | date}}</td>
                      </tr>

                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->
    </div>
  </div>
